import { pushToDataLayer } from '../dataLayer'
import { AnalyticsProductType, AnalyticsFormMode } from './types'

const RegisterProductManually = (): void => {
  pushToDataLayer({
    event: 'select_content',
    content_type: 'portal-seller:produtos',
    content_id: 'cadastrar-manualmente',
  })
}

const UploadProductSpreadsheet = (): void => {
  pushToDataLayer({
    event: 'select_content',
    content_type: 'portal-seller:produtos',
    content_id: 'subir-planilha-produtos',
  })
}

const ChooseProductType = (productType: AnalyticsProductType): void => {
  pushToDataLayer({
    event: 'select_content',
    content_type: 'portal-seller:produtos:cadastrar-manualmente',
    content_id: productType,
  })
}

const ViewProductVideo = (): void => {
  pushToDataLayer({
    event: 'video_start',
    content_type: 'portal-seller:produtos:cadastrar-manualmente',
    content_id:
      'view_video: Cadastrando minha loja - Entenda como cadastrar os produtos no Portal Magalu',
  })
}

const SelectProductCategory = (): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: 'portal-seller:produtos: com-variacoes',
    content_id: 'dados-basicos: categoria',
  })
}

const SelectProductDepartment = (): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: 'portal-seller:produtos: com-variacoes',
    content_id: 'dados-basicos: departamento',
  })
}

const ConfirmProductCategoryAndDepartment = (): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: 'portal-seller:produtos: com-variacoes',
    content_id: 'dados-basicos: confirmar-categorizacao',
  })
}

const ProductBasicDataRelevanceClicked = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: 'titulo-da-oferta: conteudo-relevante',
  })
}

const ProductAnatelCertificationLinkClicked = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: 'certificacao-e-registro-anatel: conteudo-relevante',
  })
}

const ProductVariationsRelevanceClicked = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: 'variacoes-do-produto: conteudo-relevante',
  })
}

const ProductDatasheetRelevanceClicked = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: 'ficha-tecnica: conteudo-relevante',
  })
}

const ProductDescriptionRelevanceClicked = (formMode: AnalyticsFormMode): void => {
  pushToDataLayer({
    event: 'form_interaction',
    content_type: `portal-seller:produtos: ${formMode}`,
    content_id: 'descreva-o-produto: conteudo-relevante',
  })
}

export {
  RegisterProductManually,
  UploadProductSpreadsheet,
  ChooseProductType,
  ViewProductVideo,
  SelectProductCategory,
  SelectProductDepartment,
  ConfirmProductCategoryAndDepartment,
  ProductBasicDataRelevanceClicked,
  ProductAnatelCertificationLinkClicked,
  ProductVariationsRelevanceClicked,
  ProductDatasheetRelevanceClicked,
  ProductDescriptionRelevanceClicked,
}
